import { BrowserTitleService } from '../services/BrowserTitleService';
import { CreateSiteAction } from '../services/CreateSiteAction';

export interface IAddSiteScope extends ng.IScope {
  createSite: () => void;
}

export class AddSiteCtrl {

  public static $inject = [
    '$scope',
    '$state',
    'BrowserTitleService',
    'CreateSiteAction'
  ];

  constructor(
    scope: IAddSiteScope,
    $state: ng.ui.IStateService,
    BrowserTitleService: BrowserTitleService,
    createSiteAction: CreateSiteAction
  ) {
    BrowserTitleService.setTitleWithPlace({translatablePlaceName: 'serverSettings_addSite'});
    scope.createSite = () => createSiteAction.execute(scope)
      .then(() => $state.go('main.server.sites.sites'));
  }

}
